import { createFileRoute } from '@tanstack/react-router';
import CalendarCallback from '@/pages/calendar-callback/CalendarCallback';

export const Route = createFileRoute('/calendar-callback')({
	component: CalendarCallback,
});
